export const InlineElements = ['span', 'sub', 'sup'];
export const BlockElements = ['div', 'p', 'li'];
//# sourceMappingURL=types.js.map